<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>消息中心</el-breadcrumb-item>
      <el-breadcrumb-item>新建消息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div style="width: 50%" v-if="orgLevel == 1">
        <span>区域：</span>
        <el-select v-model="selectAreaId" size="mini" style="width: 40%;" placeholder="请选择区域"
                   @change="getArea">
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.orgName"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%;margin-top: 20px" v-if="orgLevel < 3">
        <span>门店：</span>
        <el-select v-model="selectShopId" size="mini" style="width: 40%;" placeholder="请选择门店"
                   @change="getShop">
          <el-option
            v-for="item in shopList"
            :key="item.id"
            :label="item.orgName"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%;margin-top: 20px" v-if="orgLevel == 1">
        <span>消息模块：</span>
        <el-select v-model="selectInfoName" size="mini" style="width: 40%;" placeholder="请选择消息模块"
                   @change="getInfo">
          <el-option
            v-for="item in infos"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-top: 20px">
        <span>是否前台显示：</span>
        <el-checkbox v-model="isShow" @change="changeIsShow"></el-checkbox>
      </div>
      <div style="margin-top: 20px">
        <span>消息内容：</span>
        <el-input type="textarea" v-model="ppMsg.comment"></el-input>
      </div>
      <div style="margin-top: 20px">
        <el-button size="mini" @click="newContent">保存</el-button>
        <el-button size="mini">取消</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      userId:'',
      userName:'',
      orgLevel:'',
      infos: [
        {
          label: '通知公告',
          value: 1
        },
        {
          label:'销售管理',
          value: 2
        },
        {
          label: '会员中心',
          value: 3
        },
        {
          label: '库存管理',
          value: 4
        },
        {
          label: '员工管理',
          value: 5
        },
        {
          label: '财务管理',
          value: 6
        },
      ],
      selectAreaId:'',
      selectShopId:'',
      selectInfoName:'',
      areaList:[],
      shopList:[],
      ppMsg:{

      },
      isShow:'',
    }
  },
  methods:{
    getArea(data){
      this.selectAreaId = data;
      this.selectOrgId = data;
      if (data !== '') {
        this.loadShop(data);
      } else {
        this.shops = [];
        this.shopNames = [];
      }
    },
    getShop(data){
      this.selectShopId = data;
      this.selectOrgId = data;
    },
    getInfo(e){
      this.infos.map((item) => {
        if (item.value === e) {
          this.selectInfoName = item.label
        }
      })
    },
    changeIsShow(e){
      if (e == true) {
        this.isShow = e;
        this.ppMsg.isShow = 1
      } else {
        this.isShow = e;
        this.ppMsg.isShow = 2
      }
    },
    async loadArea(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.areaList = res.data;
      }
    },
    async loadShop(areaId){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${areaId}`);
      this.shopList = res.data;
    },
    async newContent() {
      if (this.orgLevel === 1 && this.selectOrgId === '') {
        this.selectOrgId = -1
      }
      if (this.orgLevel === 2 && this.selectOrgId === '') {
        this.selectOrgId = -2
      }
      if (this.selectOrgId === '') {
        this.$message.warning('请填写机构');
        return;
      }

      if (this.selectInfoName === '') {
        this.$message.warning('请选择消息版块');
        return;
      }
      if (this.content === '') {
        this.$message.warning('请填写消息内容');
        return;
      }

      this.ppMsg.sendOrgId = this.orgId;
      this.ppMsg.creator = this.userId;
      this.ppMsg.msgTypeName = this.selectInfoName;
      this.ppMsg.isRead = 2;
      // this.ppMsg.isShow = this.isShow;
      this.ppMsg.orgId = this.selectOrgId;
      this.ppMsg.orgLevel = this.orgLevel;

      const {data:res} = await this.$http.post(`/create/pp/message`, this.ppMsg);
      if (res.code == 200){
        this.$message.success('添加成功！');
        this.$router.go(-1);
      }
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    if (this.orgLevel == 1){
      this.loadArea();
    }
    if (this.orgLevel == 2){
      this.loadShop(this.orgId);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NewMessage.vue